import webApi from '../../WebApi/WebApi';


//Policy on Transportable list
export const getAllPolicyTransportableList = async () => {
    return await webApi.get(`/info-pages/slug/policy-on-transportable-goods-and-items`);
}